import axios from 'axios';
import { API_ROUTES } from '@/config/api-routes';
import { appendCriteriaEquals, appendCriteriaGreaterThanOrEqual, } from '@/shared/utils/spring-api';
/** Only match CONNECT rows from the last minute (avoids stale queue logs on inbound ring). */
const CONNECT_QUEUE_LOG_LOOKBACK_MS = 60_000;
export function resolveAgentQueueLogName(profile) {
    const phoneUser = profile?.phoneUser?.trim();
    if (phoneUser)
        return phoneUser;
    return profile?.username?.trim() || undefined;
}
function connectQueueLogTimeLowerBound() {
    return new Date(Date.now() - CONNECT_QUEUE_LOG_LOOKBACK_MS).toISOString();
}
/**
 * Latest CONNECT queue log for the logged-in agent (`GET /api/queue-logs/latest`).
 * Filters `time.greaterThanOrEqual` to one minute before now so only the current call matches.
 */
export async function fetchLatestConnectQueueLog(agent) {
    const trimmed = agent.trim();
    if (!trimmed)
        return null;
    const params = new URLSearchParams();
    appendCriteriaEquals(params, 'event', 'CONNECT');
    appendCriteriaEquals(params, 'agent', trimmed);
    appendCriteriaGreaterThanOrEqual(params, 'time', connectQueueLogTimeLowerBound());
    try {
        const { data } = await axios.get(API_ROUTES.queueLogsLatest, { params });
        return data ?? null;
    }
    catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === 404) {
            return null;
        }
        throw error;
    }
}
